export const PERMISSIONS = {
  USERS_READ: 'users.read',
  USERS_CREATE: 'users.create',
  USERS_UPDATE: 'users.update',
  USERS_DELETE: 'users.delete',
  ZONES_READ: 'zones.read',
  ZONES_CREATE: 'zones.create',
  ZONES_UPDATE: 'zones.update',
  RULES_READ: 'rules.read',
  RULES_CREATE: 'rules.create',
  RULES_UPDATE: 'rules.update',
  REPORTS_READ: 'reports.read',
  GIS_READ: 'gis.read',
  GRAPHS_READ: 'graphs.read',
  CATALOG_MANAGE: 'catalog.manage',
  PATIENTS_READ: 'patients.read',
  PATIENTS_CREATE: 'patients.create',
  PATIENTS_UPDATE: 'patients.update',
  PROFILES_MANAGE: 'profiles.manage',
  SUBMENU_ADD_PERSONA: 'submenu.addPersona.read',
  SUBMENU_ADD_PERSONA_READ: 'submenu.addPersona.read',
  SUBMENU_ADD_PERSONA_CREATE: 'submenu.addPersona.create',
  SUBMENU_ADD_PERSONA_UPDATE: 'submenu.addPersona.update',
  SUBMENU_ADD_PERSONA_DELETE: 'submenu.addPersona.delete',
  SUBMENU_ADD_CONTACTOS: 'submenu.addContactos.read',
  SUBMENU_ADD_CONTACTOS_READ: 'submenu.addContactos.read',
  SUBMENU_ADD_CONTACTOS_CREATE: 'submenu.addContactos.create',
  SUBMENU_ADD_CONTACTOS_UPDATE: 'submenu.addContactos.update',
  SUBMENU_ADD_CONTACTOS_DELETE: 'submenu.addContactos.delete',
  SUBMENU_ADD_PAIS: 'submenu.addPais.read',
  SUBMENU_ADD_PAIS_READ: 'submenu.addPais.read',
  SUBMENU_ADD_PAIS_CREATE: 'submenu.addPais.create',
  SUBMENU_ADD_PAIS_UPDATE: 'submenu.addPais.update',
  SUBMENU_ADD_PAIS_DELETE: 'submenu.addPais.delete',
  SUBMENU_ADD_TIPO_DOCUMENTO: 'submenu.addTipoDocumento.read',
  SUBMENU_ADD_TIPO_DOCUMENTO_READ: 'submenu.addTipoDocumento.read',
  SUBMENU_ADD_TIPO_DOCUMENTO_CREATE: 'submenu.addTipoDocumento.create',
  SUBMENU_ADD_TIPO_DOCUMENTO_UPDATE: 'submenu.addTipoDocumento.update',
  SUBMENU_ADD_TIPO_DOCUMENTO_DELETE: 'submenu.addTipoDocumento.delete',
  SUBMENU_ADD_TIPO_DOMICILIO: 'submenu.addTipoDomicilio.read',
  SUBMENU_ADD_TIPO_DOMICILIO_READ: 'submenu.addTipoDomicilio.read',
  SUBMENU_ADD_TIPO_DOMICILIO_CREATE: 'submenu.addTipoDomicilio.create',
  SUBMENU_ADD_TIPO_DOMICILIO_UPDATE: 'submenu.addTipoDomicilio.update',
  SUBMENU_ADD_TIPO_DOMICILIO_DELETE: 'submenu.addTipoDomicilio.delete',
  SUBMENU_ADD_ESTADO: 'submenu.addEstado.read',
  SUBMENU_ADD_ESTADO_READ: 'submenu.addEstado.read',
  SUBMENU_ADD_ESTADO_CREATE: 'submenu.addEstado.create',
  SUBMENU_ADD_ESTADO_UPDATE: 'submenu.addEstado.update',
  SUBMENU_ADD_ESTADO_DELETE: 'submenu.addEstado.delete',
  SUBMENU_ADD_PATOLOGIA: 'submenu.addPatologia.read',
  SUBMENU_ADD_PATOLOGIA_READ: 'submenu.addPatologia.read',
  SUBMENU_ADD_PATOLOGIA_CREATE: 'submenu.addPatologia.create',
  SUBMENU_ADD_PATOLOGIA_UPDATE: 'submenu.addPatologia.update',
  SUBMENU_ADD_PATOLOGIA_DELETE: 'submenu.addPatologia.delete',
  SUBMENU_ADD_SINTOMAS: 'submenu.addSintomas.read',
  SUBMENU_ADD_SINTOMAS_READ: 'submenu.addSintomas.read',
  SUBMENU_ADD_SINTOMAS_CREATE: 'submenu.addSintomas.create',
  SUBMENU_ADD_SINTOMAS_UPDATE: 'submenu.addSintomas.update',
  SUBMENU_ADD_SINTOMAS_DELETE: 'submenu.addSintomas.delete',
  SUBMENU_ADD_COMORBILIDAD: 'submenu.addComorbilidad.read',
  SUBMENU_ADD_COMORBILIDAD_READ: 'submenu.addComorbilidad.read',
  SUBMENU_ADD_COMORBILIDAD_CREATE: 'submenu.addComorbilidad.create',
  SUBMENU_ADD_COMORBILIDAD_UPDATE: 'submenu.addComorbilidad.update',
  SUBMENU_ADD_COMORBILIDAD_DELETE: 'submenu.addComorbilidad.delete',
  SUBMENU_CREAR_PERFIL: 'submenu.crearPerfil.read',
  SUBMENU_CREAR_PERFIL_READ: 'submenu.crearPerfil.read',
  SUBMENU_CREAR_PERFIL_CREATE: 'submenu.crearPerfil.create',
  SUBMENU_CREAR_PERFIL_UPDATE: 'submenu.crearPerfil.update',
  SUBMENU_CREAR_PERFIL_DELETE: 'submenu.crearPerfil.delete',
  SUBMENU_ADD_ESTADO_PATOLOGIA: 'submenu.addEstadoPorPatologia.read',
  SUBMENU_ADD_ESTADO_PATOLOGIA_READ: 'submenu.addEstadoPorPatologia.read',
  SUBMENU_ADD_ESTADO_PATOLOGIA_CREATE: 'submenu.addEstadoPorPatologia.create',
  SUBMENU_ADD_ESTADO_PATOLOGIA_UPDATE: 'submenu.addEstadoPorPatologia.update',
  SUBMENU_ADD_ESTADO_PATOLOGIA_DELETE: 'submenu.addEstadoPorPatologia.delete',
  SUBMENU_ADD_SINTOMA_PATOLOGIA: 'submenu.addSintomaPorPatologia.read',
  SUBMENU_ADD_SINTOMA_PATOLOGIA_READ: 'submenu.addSintomaPorPatologia.read',
  SUBMENU_ADD_SINTOMA_PATOLOGIA_CREATE: 'submenu.addSintomaPorPatologia.create',
  SUBMENU_ADD_SINTOMA_PATOLOGIA_UPDATE: 'submenu.addSintomaPorPatologia.update',
  SUBMENU_ADD_SINTOMA_PATOLOGIA_DELETE: 'submenu.addSintomaPorPatologia.delete',
  SUBMENU_ADD_COMORBILIDAD_PATOLOGIA: 'submenu.addComorbilidadPorPatologia.read',
  SUBMENU_ADD_COMORBILIDAD_PATOLOGIA_READ: 'submenu.addComorbilidadPorPatologia.read',
  SUBMENU_ADD_COMORBILIDAD_PATOLOGIA_CREATE: 'submenu.addComorbilidadPorPatologia.create',
  SUBMENU_ADD_COMORBILIDAD_PATOLOGIA_UPDATE: 'submenu.addComorbilidadPorPatologia.update',
  SUBMENU_ADD_COMORBILIDAD_PATOLOGIA_DELETE: 'submenu.addComorbilidadPorPatologia.delete',
  SUBMENU_ADD_ESTUDIOS: 'submenu.addEstudios.read',
  SUBMENU_ADD_ESTUDIOS_READ: 'submenu.addEstudios.read',
  SUBMENU_ADD_ESTUDIOS_CREATE: 'submenu.addEstudios.create',
  SUBMENU_ADD_ESTUDIOS_UPDATE: 'submenu.addEstudios.update',
  SUBMENU_ADD_ESTUDIOS_DELETE: 'submenu.addEstudios.delete',
  SUBMENU_ADD_ESTUDIO_PATOLOGIA: 'submenu.addEstudioPorPatologia.read',
  SUBMENU_ADD_ESTUDIO_PATOLOGIA_READ: 'submenu.addEstudioPorPatologia.read',
  SUBMENU_ADD_ESTUDIO_PATOLOGIA_CREATE: 'submenu.addEstudioPorPatologia.create',
  SUBMENU_ADD_ESTUDIO_PATOLOGIA_UPDATE: 'submenu.addEstudioPorPatologia.update',
  SUBMENU_ADD_ESTUDIO_PATOLOGIA_DELETE: 'submenu.addEstudioPorPatologia.delete',
  SUBMENU_ADD_ATRIBUTOS: 'submenu.addAtributos.read',
  SUBMENU_ADD_ATRIBUTOS_READ: 'submenu.addAtributos.read',
  SUBMENU_ADD_ATRIBUTOS_CREATE: 'submenu.addAtributos.create',
  SUBMENU_ADD_ATRIBUTOS_UPDATE: 'submenu.addAtributos.update',
  SUBMENU_ADD_ATRIBUTOS_DELETE: 'submenu.addAtributos.delete',
  SUBMENU_ADD_ATRIBUTO_PATOLOGIA: 'submenu.addAtributoPorPatologia.read',
  SUBMENU_ADD_ATRIBUTO_PATOLOGIA_READ: 'submenu.addAtributoPorPatologia.read',
  SUBMENU_ADD_ATRIBUTO_PATOLOGIA_CREATE: 'submenu.addAtributoPorPatologia.create',
  SUBMENU_ADD_ATRIBUTO_PATOLOGIA_UPDATE: 'submenu.addAtributoPorPatologia.update',
  SUBMENU_ADD_ATRIBUTO_PATOLOGIA_DELETE: 'submenu.addAtributoPorPatologia.delete',
  SUBMENU_ZONAS_SANITARIAS: 'submenu.zonasSanitarias.read',
  SUBMENU_ZONAS_SANITARIAS_READ: 'submenu.zonasSanitarias.read',
  SUBMENU_ZONAS_SANITARIAS_CREATE: 'submenu.zonasSanitarias.create',
  SUBMENU_ZONAS_SANITARIAS_UPDATE: 'submenu.zonasSanitarias.update',
  SUBMENU_ZONAS_SANITARIAS_DELETE: 'submenu.zonasSanitarias.delete',
  SUBMENU_ZONAS_GEOGRAFICAS: 'submenu.zonasGeograficas.read',
  SUBMENU_ZONAS_GEOGRAFICAS_READ: 'submenu.zonasGeograficas.read',
  SUBMENU_ZONAS_GEOGRAFICAS_CREATE: 'submenu.zonasGeograficas.create',
  SUBMENU_ZONAS_GEOGRAFICAS_UPDATE: 'submenu.zonasGeograficas.update',
  SUBMENU_ZONAS_GEOGRAFICAS_DELETE: 'submenu.zonasGeograficas.delete',
  SUBMENU_AREAS_PROGRAMATICAS: 'submenu.areasProgramaticas.read',
  SUBMENU_AREAS_PROGRAMATICAS_READ: 'submenu.areasProgramaticas.read',
  SUBMENU_AREAS_PROGRAMATICAS_CREATE: 'submenu.areasProgramaticas.create',
  SUBMENU_AREAS_PROGRAMATICAS_UPDATE: 'submenu.areasProgramaticas.update',
  SUBMENU_AREAS_PROGRAMATICAS_DELETE: 'submenu.areasProgramaticas.delete',
  SUBMENU_ADD_VACUNAS: 'submenu.addVacunas.read',
  SUBMENU_ADD_VACUNAS_READ: 'submenu.addVacunas.read',
  SUBMENU_ADD_VACUNAS_CREATE: 'submenu.addVacunas.create',
  SUBMENU_ADD_VACUNAS_UPDATE: 'submenu.addVacunas.update',
  SUBMENU_ADD_VACUNAS_DELETE: 'submenu.addVacunas.delete',
  SUBMENU_ADD_MEDICACIONES: 'submenu.addMedicaciones.read',
  SUBMENU_ADD_MEDICACIONES_READ: 'submenu.addMedicaciones.read',
  SUBMENU_ADD_MEDICACIONES_CREATE: 'submenu.addMedicaciones.create',
  SUBMENU_ADD_MEDICACIONES_UPDATE: 'submenu.addMedicaciones.update',
  SUBMENU_ADD_MEDICACIONES_DELETE: 'submenu.addMedicaciones.delete',
  SUBMENU_GRUPOS_ETARIOS: 'submenu.gruposEtarios.read',
  SUBMENU_GRUPOS_ETARIOS_READ: 'submenu.gruposEtarios.read',
  SUBMENU_GRUPOS_ETARIOS_CREATE: 'submenu.gruposEtarios.create',
  SUBMENU_GRUPOS_ETARIOS_UPDATE: 'submenu.gruposEtarios.update',
  SUBMENU_GRUPOS_ETARIOS_DELETE: 'submenu.gruposEtarios.delete',
  SUBMENU_ESTABLECIMIENTOS_DIAGNOSTICO: 'submenu.establecimientosDiagnostico.read',
  SUBMENU_ESTABLECIMIENTOS_DIAGNOSTICO_READ: 'submenu.establecimientosDiagnostico.read',
  SUBMENU_ESTABLECIMIENTOS_DIAGNOSTICO_CREATE: 'submenu.establecimientosDiagnostico.create',
  SUBMENU_ESTABLECIMIENTOS_DIAGNOSTICO_UPDATE: 'submenu.establecimientosDiagnostico.update',
  SUBMENU_ESTABLECIMIENTOS_DIAGNOSTICO_DELETE: 'submenu.establecimientosDiagnostico.delete',
  SUBMENU_INSTITUCIONES_SEGUIMIENTO_TRATAMIENTO: 'submenu.institucionesSeguimientoTratamiento.read',
  SUBMENU_INSTITUCIONES_SEGUIMIENTO_TRATAMIENTO_READ: 'submenu.institucionesSeguimientoTratamiento.read',
  SUBMENU_INSTITUCIONES_SEGUIMIENTO_TRATAMIENTO_CREATE: 'submenu.institucionesSeguimientoTratamiento.create',
  SUBMENU_INSTITUCIONES_SEGUIMIENTO_TRATAMIENTO_UPDATE: 'submenu.institucionesSeguimientoTratamiento.update',
  SUBMENU_INSTITUCIONES_SEGUIMIENTO_TRATAMIENTO_DELETE: 'submenu.institucionesSeguimientoTratamiento.delete',
  SUBMENU_EVOLUCIONES_CLINICO_TERAPEUTICAS: 'submenu.evolucionesClinicoTerapeuticas.read',
  SUBMENU_EVOLUCIONES_CLINICO_TERAPEUTICAS_READ: 'submenu.evolucionesClinicoTerapeuticas.read',
  SUBMENU_EVOLUCIONES_CLINICO_TERAPEUTICAS_CREATE: 'submenu.evolucionesClinicoTerapeuticas.create',
  SUBMENU_EVOLUCIONES_CLINICO_TERAPEUTICAS_UPDATE: 'submenu.evolucionesClinicoTerapeuticas.update',
  SUBMENU_EVOLUCIONES_CLINICO_TERAPEUTICAS_DELETE: 'submenu.evolucionesClinicoTerapeuticas.delete',
  SUBMENU_SECTORES_SUBSECTORES: 'submenu.sectoresSubsectores.read',
  SUBMENU_SECTORES_SUBSECTORES_READ: 'submenu.sectoresSubsectores.read',
  SUBMENU_SECTORES_SUBSECTORES_CREATE: 'submenu.sectoresSubsectores.create',
  SUBMENU_SECTORES_SUBSECTORES_UPDATE: 'submenu.sectoresSubsectores.update',
  SUBMENU_SECTORES_SUBSECTORES_DELETE: 'submenu.sectoresSubsectores.delete',
  SUBMENU_ADD_VACUNAS_PATOLOGIA: 'submenu.addVacunasPorPatologia.read',
  SUBMENU_ADD_VACUNAS_PATOLOGIA_READ: 'submenu.addVacunasPorPatologia.read',
  SUBMENU_ADD_VACUNAS_PATOLOGIA_CREATE: 'submenu.addVacunasPorPatologia.create',
  SUBMENU_ADD_VACUNAS_PATOLOGIA_UPDATE: 'submenu.addVacunasPorPatologia.update',
  SUBMENU_ADD_VACUNAS_PATOLOGIA_DELETE: 'submenu.addVacunasPorPatologia.delete',
  SUBMENU_ADD_MEDICACION_PATOLOGIA: 'submenu.addMedicacionPorPatologia.read',
  SUBMENU_ADD_MEDICACION_PATOLOGIA_READ: 'submenu.addMedicacionPorPatologia.read',
  SUBMENU_ADD_MEDICACION_PATOLOGIA_CREATE: 'submenu.addMedicacionPorPatologia.create',
  SUBMENU_ADD_MEDICACION_PATOLOGIA_UPDATE: 'submenu.addMedicacionPorPatologia.update',
  SUBMENU_ADD_MEDICACION_PATOLOGIA_DELETE: 'submenu.addMedicacionPorPatologia.delete',
};
